<template>
    <div class="content">

        <div class="intro">

            <div class="overlay">

                <div class="wrapper">
                    <p class="subline">DISCLAIMER</p>
                    <h1 class="headline">PRIVACY POLICY</h1>
                </div>

            </div>

        </div>    

        <div class="text__container">

            <p class="large__text">Table of contents</p>

            <p>You can use this table of contents to move through our privacy policy and find what you need. Click on a link for a specific section and you'll jump right to it.</p>
            <ul>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('thanks')">Thank You for Using Our Website!</div>
                </li>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('whoweare')">Who are We?</div>
                </li>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('legal')">Legal Grounds for Personal Data Processing</div>
                </li>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('personal')">Personal Data We Collect and How We Use </div>
                </li>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('collect')">We Collect Personal Data in a Few Different Ways</div>
                </li>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('keep')">How Long We Keep Your Personal Data</div>
                </li>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('transfer')">Transferring Your Personal Data</div>
                </li>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('secure')">How Do We Keep Your Personal Data Secure</div>
                </li>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('rights')">Your Rights</div>
                </li>
                <li class="fixed-width">
                    <div class="section-link" @click="scrollToSection('contact')">Contact Us</div>
                </li>
            </ul>





            <p class="section__headline" id="thanks">Thank You for Using Our Website!</p>

            <p>
                We wrote this policy to help you understand which personal data we collect, how we use it and what choices you have about it. Some of the concepts below are a little technical, but we’ve tried our best to explain things simply and clearly.
            </p>
            <p>
                By using our website, you agree to the terms of this policy.
            </p>





            <p class="section__headline" id="whoweare">Who are We?</p>

            <p>
                Gate21 d.o.o. (“we”, “us”) is a subsidiary of THQ Nordic GmbH company with a head office based in Vienna, Austria. We are part of the global Embracer Group with a head office based in Karlstad, Sweden having a global presence in more than 40 countries. 
            </p>





            <p class="section__headline" id="legal">Legal Grounds for Personal Data Processing</p>

            <p>
                We may process your personal data on legal grounds governed by 
            </p>

            <ul>
                <li>
                    (i)	Personal Data Protection Act of Bosnia and Herzegovina  
                </li>
                <li>
                    (ii)	General Data Protection Regulation (Regulation (EU) 2016/679) (GDPR). 
                </li>
            </ul>

            <p>
                As part of its efforts to join the EU, Bosnia and Herzegovina (BiH) is obliged to harmonise its legislation with EU legislation. This includes the GDPR, which applies to BiH companies when offering goods or services to data subjects in the EU.0
            </p>

            <p>
                Lawful grounds for personal data processing include consent, contractual necessity and our “legitimate interests” or the legitimate interest of others, as further described below. In some cases, we process personal data based on the consent you expressly grant to us at the time we collect such personal data. 
            </p>

            <p>
                When we process personal data based on your consent, it will be expressly indicated to you at the point and time of collection. 
            </p>

            <p>
                From time to time, we may also need to process personal data to comply with a legal obligation, if it is necessary to protect the vital interests of you or other data subjects, or if it is necessary for a task carried out in the public interest.
            </p>





            <p class="section__headline" id="personal">Personal Data We Collect and How We Use It</p>

            <ul>
                <li>
                    <span class="bold">Client</span> data is actually very limited. We generally only need to have your contact details or the details of individual contacts at your organisation (such as their names, telephone numbers, email addresses, country, job title) to enable us to ensure that our relationship runs smoothly. 
                </li>
                <li>
                    <span class="bold">Employment candidate data</span> includes name, age/date of birth, sex/gender, photograph, contact details, education details, employment history, emergency contacts, referee details, social security number, extra information applicant chooses to tell us, IP address. 
                </li>
                <li>
                    <span class="bold">Website users</span>: we collect anonymous data from every visitor of the website (IP address, browser type, timestamp etc.) 
                </li>
            </ul>

            <p>
                We <span class="colored">do not disclose collected personal data</span> to third parties and we use it <span class="colored">exclusively</span> for communication with those visitors explicitly requesting contact, potential job applicants and for handling the services and products offered on the website. 
            </p>

            <p>
                We use collected personal data <span class="colored">solely for internal use</span> and these <span class="colored">specific purposes</span>.
            </p>





            <p class="section__headline" id="collect">We Collect Personal Data in a Few Different Ways</p>

            <p>
                When you contact us directly through a website form, registering on our website requesting our services, during the job application process, commenting to our blog or signing up for our newsletter, you are <span class="colored">voluntarily sharing certain personal data</span> such as your name, email address, phone number or other personal data requested by a form.
            </p>

            <p>
                We are using Google Maps, Google Analytics, Google Fonts, Google reCAPTCHA, Google+ and we embedded social media elements (Facebook, Facebook Pixel, YouTube, Twitter, Instagram, LinkedIn, Pinterest) to our website.  This means that if you give your consent by ticking the box, certain <span class="colored">personal data collected on our website during your visit may be communicated from your browser to respective social media service and will be stored there</span>.
            </p>

            <p>
                The USA does not have an adequate level of data protection and there is a risk that US authorities may gain access to your data without any effective legal protection.
            </p>

            <p>
                What personal data respective social media collects and how do they use personal data can be found on the following links: 
            </p>


            <a class="policy_link" href="https://www.google.com/intl/en/policies/privacy/" target="_blank">Google Maps Privacy Policy</a>
        
            <a class="policy_link" href="https://www.google.com/analytics/terms/us.html" target="_blank">Google Analytics Privacy Policy (US)</a>
        
            <a class="policy_link" href="https:/support.google.com/analytics/answer/6004245?hl=en." target="_blank">Google Analytics Privacy Policy (EN)</a>
        
            <a class="policy_link" href="https://www.google.com/intl/en/policies/privacy/" target="_blank">Google Fonts Privacy Policy</a>
        
            <a class="policy_link" href="https://policies.google.com/terms?hl=en" target="_blank">Google reCAPTCHA</a>
        
            <a class="policy_link" href="https://www.facebook.com/policy.php" target="_blank">Facebook Privacy Policy</a>
        
            <a class="policy_link" href="https://www.google.com/intl/en/policies/privacy/" target="_blank">YouTube Privacy Policy</a>
        
            <a class="policy_link" href="https://twitter.com/privacy" target="_blank">Twitter Privacy Policy</a>
        
            <a class="policy_link" href="https://www.google.com/intl/en/policies/privacy/" target="_blank">Google+ Privacy Policy</a>
        
            <a class="policy_link" href="https://help.instagram.com/155833707900388" target="_blank">Instagram Privacy Policy</a>
        
            <a class="policy_link" href="https://www.linkedin.com/legal/privacy-policy" target="_blank">LinkedIn Privacy Policy</a>
        
            <a class="policy_link" href="https://policy.pinterest.com/en/privacy-policy" target="_blank">Pinterest Privacy Policy</a>
        
            <a class="policy_link" href="https://www.facebook.com/business/learn/facebook-ads-pixel" target="_blank">Facebook Pixel Privacy Policy</a>
                

            <ul class="no_padding">
                <li class="mb-4">
                    <span class="bold_colored">Contact through the website:</span> the website contains information that allows visitors to contact us quickly and to communicate with us directly, which also includes a general email address. If you contact us by e-mail or directly through a website embedded contact form, the personal data you provided will be automatically saved and stored for processing or contacting the respective person. 
                </li>
                <li class="mb-4">
                    <span class="bold_colored">Job application process:</span> we collect and process the personal data of job applicants to handle the entire application process. The processing can also be done electronically. This is particularly the case if an applicant submits corresponding application documents to the data processor by electronic means, for example by e-mail or a contact form on the website. If we conclude a contract of employment with an applicant, the personal data transmitted will be stored for the purposes of the employment relationship in accordance with the law. If no contract of employment with the candidate is concluded with us, the application documents will be automatically deleted <span class="colored">six months</span> after receipt of the application, provided that deletion does not conflict with any other legitimate interests of the Company. 
                </li>
                <li>
                    <span class="bold_colored">Newsletter:</span> If you subscribe to our newsletter, you submit your personal data and give us the right to contact you via email. We use the personal data stored in the registration for the newsletter exclusively for our newsletter and do not disclose them to third parties.
                    <br>If you unsubscribe from the newsletter - you will find the link in each newsletter at the bottom - then we delete all personal data that was saved with the registration for the newsletter.
                </li>
            </ul>

            <p class="section__headline">We also Get Technical Information When You Use Our Website (Automatic Data Storage)</p>

            <p>
                When you use a website, mobile application or other internet services, certain internet and electronic network activity information gets created and logged automatically. This is also true when you visit our website. Here are some of the types of information we collect:
            </p>

            <ul class="no_padding">
                <li class="mb-4">
                    <span class="bold_colored">Log data</span>: when you visit our website, our servers automatically record and store information <strong>(Log data)</strong>, including information that your browser automatically sends whenever you visit a website or mobile app. This log includes your Internet Protocol address (which we use to infer your approximate location), subpages addressed, date and time.
                    <br>This information is kept safe, not used for internal purposes and will not be disclosed to third parties, but we cannot guarantee that it will not be used in the event of unlawful behaviour.
                </li>
                <li class="mb-4">
                    <span class="bold_colored">Cookies data</span>: we also use “cookies” which help web developers give you more personal, convenient website visits. Cookies let websites remember you, your website logins, shopping carts and more, making your website experience more user-friendly.
                    <br><br> In more technical terms, cookies are text files with small pieces of data — like a username and password — that are used to identify your computer as you use a computer network. Specific cookies known as HTTP cookies are used to identify specific users and improve your web browsing experience. 
                    <br><br> Data stored in a cookie is created by the server upon your connection. This data is labelled with an ID unique to you and your computer. When the cookie is exchanged between your computer and the network server, the server reads the ID and knows what information to specifically serve to you.
                    <br><br> You can <span class="color">delete or disable cookies</span> on your computer and procedures varies from browser to browser. A simple google search will provide you with clear instructions on how to do this. 
                    <br><br> However, in case you delete or disable cookies, some features or pages may not work as expected.
                </li>
            </ul>





            <p class="section__headline" id="keep">How Long We Keep Your Personal Data</p>

            <p>
                We keep your personal data only <span class="colored">so long as we need it to provide our products or services and fulfil the purposes described in this policy</span>. This is also the case for anyone that we share your personal data with and who carries out services on our behalf. 
            </p>

            <p>
                When we no longer need to use your personal data and there is no need for us to keep it to comply with our legal or regulatory obligations, we'll either remove it from our systems or depersonalize it so that we can't identify you.
            </p>

            <p>
                We use your personal data <span class="colored">exclusively for communication with those visitors</span> who expressly request contact and for the handling of the services and products offered on this website. We will not disclose your personal data without consent, but we cannot rule out that personal data will be seen in the event of unlawful behaviour.
            </p>

            <p>
                If you send us personal data via e-mail - i.e., outside of this website - we can’t guarantee secure transmission and protection of your data. We recommend that you never send data by e-mail unencrypted.
            </p>





            <p class="section__headline" id="transfer">Transferring Your Personal Data</p>

            <p>
                We are part of the global group with global practice in more than 40 countries providing a worldwide service. By using our products or services, you authorize us to transfer and store your personal data outside your home country, including in Austria and Sweden, for the purposes described in this policy. 
            </p>

            <p>
                When we transfer personal data from the BiH to a country that doesn't provide an adequate level of protection, we'll only do so under appropriate safeguards to protect your personal data, such as standard contractual clauses in line with Article 18 of the Personal Data Protection Act BiH. 
            </p>

            <p>
                If you have any questions about our data processing activities, the data controller you should contact is <strong>Gate21 d.o.o.</strong> with its registered office at City Centre Complex, ul. Vrbanja no. 1, 16th floor, Sarajevo, BiH.
            </p>

            <p>
                If you think we haven't complied with data protection laws, you have the right to lodge a complaint with the Personal Data Protection Agency in BiH.
            </p>





            <p class="section__headline" id="secure">How Do We Keep Your Personal Data Secure</p>

            <p>
                We use https to transfer personal data securely on the Internet. By using TLS (Transport Layer Security), an encryption protocol for secure data transmission over the Internet, we can ensure the protection of personal data. You acknowledge the use of this security of personal data transfer at the small lock symbol in the upper left corner of the browser and the use of the https scheme as part of our Internet address.
            </p>





            <p class="section__headline" id="rights">Your rights</p>

            <p>You have options in relation to the personal data that we have about you:</p>

            <ol>
                <li class="mb-4">
                    <span class="bold_colored">Right to be Informed:</span> this means that we have to make clear what are we processing, why and who else the data may be passed to.
                </li>
                <li class="mb-4">
                    <span class="bold_colored">Right of Access:</span> this is your right to see what data we collect and hold about you. We'll usually share this with you within 30 days of you requesting the access.
                </li>
                <li class="mb-4">
                    <span class="bold_colored">Right to Rectification:</span> have your personal data corrected or deleted. You can update your personal data or delete data we have on you. 
                </li>
                <li class="mb-4">
                    <span class="bold_colored">Right to Erasure:</span> under certain circumstances, you can ask for your personal data to be deleted. This is also called “the Right to be Forgotten”. This would apply if the personal data is no longer required for the purposes it was collected for, or your consent for the processing of that data has been withdrawn or the personal data has been unlawfully processed.
                </li>
                <li class="mb-4">
                    <span class="bold_colored">Right to Restrict Processing:</span> allows you to ask for a temporary half to processing of personal data, such as in the case where a dispute or legal case has to be concluded or the data is being corrected
                </li>
                <li class="mb-4">
                    <span class="bold_colored">Rights to Data Portability:</span> have the personal data you provided to us <span class="bold_colored">sent to another organization</span>, where we hold this personal data with your consent or for the performance of a contract with you, and, where it's technically feasible for us to do so.
                </li>
                <li class="mb-4">
                    <span class="bold_colored">Right to Object:</span> You can ask us to stop using your personal data, including when we use your personal data to send you marketing emails or push notifications.
                </li>
                <li class="mb-4">
                    <span class="bold_colored">Rights in relation to automated decision making and profiling:</span> you have the right not to be subject to a decision based solely on automated processing. 
                </li>
            </ol>

            <p>
                If you believe that the processing of your data violates data protection law or if your data protection claims have otherwise been violated in a way, you can complain to the supervisory authority. In BiH, this is the Data Protection Authority whose websites you can find on this <a class="text-link" href="http://www.azlp.ba/Default.aspx?langTag=bs-BA&template_id=147&pageIndex=1" target="_blank">link</a>.
            </p>

            <p>
                We will not discriminate against you if you choose to exercise your options related to your personal data. We work to be clear with you about your options and the consequences of exercising certain options. 
            </p>





            <p class="section__headline" id="contact">Contact Us</p>

            <p>
                The best way to get in touch with us or to exercise your options described above is through the contacts below:
            </p>

            <p>
                You can contact <strong>Gate21 d.o.o.</strong> with its registered office at City Centre Complex, ul. Vrbanja no. 1, 16th floor, Sarajevo, BiH.
            </p>

            <div class="contact-box">
                <p>Tel:</p>
                <a href="tel:+38733211221">+387 33 21 12 21 </a>
            </div>
            <div class="contact-box">
                <p>Email: </p>
                <a href="mailto:info@gate21.com">info@gate21.com</a>
            </div>
        
            <p>Effective date: <strong>1.9.2023</strong></p>

        </div>

    </div>

</template>
<script>
export default {
    data(){
        return {}
    },
    props: ['news', 'all_news', 'featured'],
    methods: {
        get_news_image(){
            return "url('" + '/image/' + this.news.media_path + '/' + this.news.featured_image + "')";
        },
        scrollToSection(section_id){
            const section  = document.getElementById(section_id);
            const yPos = section.offsetTop - document.getElementsByTagName('header')[0].clientHeight - 20;
            window.scrollTo(0, yPos);
        }
    }
}
</script>
<style lang="scss" scoped>

    .content{
        display: flex;
        flex-direction: column;

        .intro{
            position: relative;
            height: 100vh;

            background: url('/images/contact/hero.webp');
            background-repeat: no-repeat;
            background-position: center -140px;
            background-size: cover;
            background-color: black;
            

            .overlay{
                display: block;
                width: 100%;
                height: 100%;
                position: relative;

                background: rgba(92, 44, 144, 0.6);

                .wrapper{
                    display: block;
                    position: absolute;
                    top: 50%; right: 50%;
                    transform: translate(50%, -50%);
                    // width: 976px;
                    width: 100%;
                    max-width: 1020px;
                    height: auto;

                    .subline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 50px;
                        line-height: 60px;
                        text-align: center;
                        text-transform: uppercase;

                        color: #ED1163;
                        margin-bottom: 0;
                    }

                    h1.headline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 175px;
                        line-height: 175px;
                        text-align: center;
                        /* or 100% */
                        margin: 0;
                        text-transform: uppercase;

                        color: #FFFFFF;

                        margin-left: -5px;
                    }

                    .description{
                        font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 18px;
                        line-height: 22px;

                        color: #FFFFFF;

                        margin: 0;
                        margin-top: 22px;
                        // text-align: center;
                        text-align: left;
                        width: 100%;
                        // max-width: 454px;
                        margin-left: 0;
                        margin-right: auto;

                        color: #FFFFFF;
                    }


                }

            }
        }

        .text__container{
            display: flex;
            flex-direction: column;
            width: 100%;
            max-width: 990px;
            margin: 0 auto;

            padding: 42px 0;

            p{
                font-family: "DIN Next LT Pro Ultralight";
                font-style: normal;
                font-size: 18px;
                line-height: 22px;
                color: #FFFFFF;

                a.text-link{
                    font-family: "DIN Next LT Pro Bold";
                    color: #ED1163;
                    font-size: 18px;
                }

                span.colored{
                    color: #ED1163;
                    font-family: 'DIN Next LT Pro Bold';
                }

                &.large__text{
                    font-family: "DIN Next LT Pro Bold";
                    font-style: normal;
                    font-size: 30px;
                    line-height: 36px;

                    text-transform: uppercase;
                }

                &.section__headline{
                    font-family: "DIN Next LT Pro Bold";
                    font-style: normal;
                    font-size: 22px;
                    line-height: 26px;
                }
            }

            ul{
                &.no_padding{
                    padding: 0;
                    margin: 32px 0;
                }

                li{
                    font-family: "DIN Next LT Pro Ultralight";
                    list-style-type: circle;
                    color: white;

                    &.fixed-width{
                        width: 100%;
                        max-width: 400px;
                    }
                    .section-link{
                        font-family: "DIN Next LT Pro Regular";
                        font-style: normal;
                        font-size: 18px;
                        line-height: 22px;
                        color: #FFFFFF;
                        cursor: pointer;

                        transition: all .3s ease;

                        &:hover{
                            color: #ED1163;
                        }
                    }

                    &.mb-4{
                        margin-bottom: 24px;
                    }

                    span.bold{
                        font-family: "DIN Next LT Pro Bold";
                    }

                    span.bold_colored{
                        font-family: "DIN Next LT Pro Bold";
                        color: #ED1163;
                        font-size: 18px;
                    }

                    a{
                        font-family: "DIN Next LT Pro Regular";
                        font-style: normal;
                        font-size: 18px;
                        line-height: 22px;
                        color: #FFFFFF;
                    }
                }
            }

            ol{

                li{
                    font-family: "DIN Next LT Pro Ultralight";
                    color: white;

                    &.mb-4{
                        margin-bottom: 24px;
                    }

                    span.bold_colored{
                        font-family: "DIN Next LT Pro Bold";
                        color: #ED1163;
                        font-size: 18px;
                    }
                }
            }
            
            .policy_link{
                font-family: "DIN Next LT Pro Regular";
                font-style: normal;
                font-size: 18px;
                line-height: 22px;
                color: white;
                text-decoration: underline;
                text-decoration-color: #ED1163;
                text-underline-offset: 3px;
                margin-bottom: 4px;
                width: 100%;
                max-width: 300px;                

                transition: all .3s ease;

                &:hover{
                    color: #ED1163;
                    text-decoration-color: #fff;
                }
            }

            .contact-box{
                display: flex;
                flex-direction: row;

                p{
                    font-family: "DIN Next LT Pro Ultralight";
                    font-style: normal;
                    font-size: 18px;
                    line-height: 22px;
                    color: #FFFFFF;
                    margin: 0;
                    width: 65px;
                }

                a{
                    font-family: "DIN Next LT Pro Bold";
                    font-style: normal;
                    font-size: 18px;
                    line-height: 22px;
                    color: #FFFFFF;
                }
            }
        }
    }

    @media screen and (max-width: 836px) {

        .content{

            .intro{
                
                .overlay{

                    .wrapper{
                        width: 100%;

                        .subline{
                            font-size: 20px;
                            line-height: 24px;
                            text-align: center;
                            margin-bottom: 15px;
                            display: block;
                        }

                        h1.headline{
                            font-size: 40px;
                            line-height: 40px;
                            text-align: center;
                        }

                        .keywords{
                            font-size: 16px;
                            line-height: 16px;
                        }

                        a.anim_button{
                            width: 100%;
                            max-width: 245px;
                            height: 35px;
                            
                            p{
                                font-size: 12px;
                                line-height: 40px;
                            }
                        }
                    }

                    .bottom__bar{
                        .text-wrap{
                            .red_text, .regular_text, .red_text.second{
                                font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                font-size: 18px;
                                line-height: 25px;
                            }   
                        }
                    }
                }
            }

            .text__container{
                width: 95%;

                p{
                    font-size: 16px;
                    line-height: 16px;

                    &.large__text{
                        font-size: 22px;
                        line-height: 26px;
                    }
                }
            }

        }

    }

</style>
